<template>
  <v-app>
    <v-content>
      <v-container>
        <v-row>
          <v-col cols="2" v-show="$vuetify.breakpoint.mdAndUp"></v-col>
          <v-col cols="12" md="8" class="mt-5">
            <h1 class="display-1 font-weight-black text-center mb-3">
              Hubungi Kami
            </h1>
            <p>
              Silahkan kirim pertanyaan, saran dan kritik kepada kami melalui
              form di bawah ini :
            </p>
          </v-col>
          <v-col cols="2" v-show="$vuetify.breakpoint.mdAndUp"></v-col>

          <v-col cols="2" v-show="$vuetify.breakpoint.mdAndUp"></v-col>
          <v-col cols="12" md="8">
            <v-alert
              :type="!error ? 'success' : 'error'"
              ref="alert"
              dismissible
              v-show="submitted"
            >
              {{ msg }}
            </v-alert>
            <v-form v-model="valid" ref="refForm">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    color="amber darken-4"
                    label="Nama"
                    outlined
                    prepend-inner-icon="mdi-account"
                    required
                    :rules="nameRules"
                    type="text"
                    v-model="name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    color="amber darken-4"
                    label="Nomor Telepon"
                    outlined
                    prepend-inner-icon="mdi-phone"
                    required
                    :rules="phoneRules"
                    type="text"
                    v-model="phone"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    color="amber darken-4"
                    label="Email"
                    outlined
                    prepend-inner-icon="mdi-email"
                    required
                    :rules="emailRules"
                    type="email"
                    v-model="email"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    color="amber darken-4"
                    label="Subyek"
                    outlined
                    prepend-inner-icon="mdi-text-subject"
                    type="text"
                    v-model="subject"
                    :rules="subjectRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    color="amber amber-darken-4"
                    label="Pesan"
                    prepend-inner-icon="mdi-message-text-outline"
                    required
                    :rules="messageRules"
                    v-model="message"
                  ></v-textarea>
                </v-col>
                <v-col class="text-center">
                  <v-btn
                    color="amber amber-darken-4"
                    :disabled="!valid"
                    @click="submitForm"
                    :loading="loading"
                    class="text--white"
                  >
                    Kirim&nbsp;<v-icon>mdi-send</v-icon>
                  </v-btn>

                  <v-btn
                    color="blue-grey lighten-2"
                    @click="resetForm"
                    class="text--white"
                  >
                    Reset&nbsp;<v-icon>mdi-reload</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
          <v-col cols="2" v-show="$vuetify.breakpoint.mdAndUp"></v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
/* eslint-disable no-console */
import axios from "axios";
import {
  SERVER_ENDPOINT,
  EMAIL_ENDPOINT,
  TRANSFORM_REQUEST,
} from "@/utils/constant";
export default {
  data() {
    return {
      name: "",
      nameRules: [
        (v) => !!v || "Nama tidak boleh kosong",
        (v) => /^[A-Za-z ]*$/.test(v) || "Isi field harus valid",
      ],
      phone: "",
      phoneRules: [
        (v) => !!v || "Telepon tidak boleh kosong",
        (v) =>
          /^(^\+62\s?|^0)(\d{3,4}-?){2}\d{3,4}$/.test(v) ||
          "Telepon harus valid",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "Email tidak boleh kosong",
        (v) =>
          /^[\w.-]+@(?:[A-Za-z-]+\.)+[A-Za-z]{2,}$/.test(v) ||
          "Email harus valid",
      ],
      subject: "",
      subjectRules: [(v) => !!v || "Subyek tidak boleh kosong"],
      message: "",
      messageRules: [(v) => !!v || "Pesan tidak boleh kosong"],
      valid: false,
      loading: false,
      submitted: false,
      error: false,
      msg: "",
    };
  },
  name: "TestUpload",
  methods: {
    async submitForm(e) {
      e.preventDefault();
      this.resetStatus();
      this.loading = true;
      try {
        const { data } = await axios.post(
          `${SERVER_ENDPOINT}${EMAIL_ENDPOINT}`,
          {
            email: this.email,
            message: this.message,
            name: this.name,
            phone: this.phone,
            subject: this.subject,
          },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            transformRequest: (jsonData) => TRANSFORM_REQUEST(jsonData),
          }
        );
        if (data.success) {
          this.error = false;
          this.msg = data.status;
        } else {
          this.error = true;
          throw new Error(data.status);
        }
        console.log(data.data);
      } catch (err) {
        this.error = true;
        this.msg = err;
      } finally {
        this.loading = false;
        this.submitted = true;
        this.resetForm();
      }
    },
    resetForm() {
      this.$refs.refForm.reset();
    },
    resetStatus() {
      this.submitted = false;
      this.error = false;
      this.msg = "";
    },
  },
};
</script>

<style></style>
